<template>
  <div class="dashboard" style="background: #111; color: #fff; min-height: 100vh; padding: 20px; font-family: 'Noto Sans', system-ui, sans-serif;">
    <h1 style="text-align: center; color: #ff9800; margin-bottom: 30px; text-shadow: 0 0 10px rgba(255, 152, 0, 0.5);">
      📈 订单销量与配送状态监控大屏
    </h1>

    <div class="grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
      <!-- 左侧：各美食销量柱状图 -->
      <div class="chart-card" style="background: #222; padding: 20px; border-radius: 12px; box-shadow: 0 4px 15px rgba(0,0,0,0.5);">
        <h3 style="color: #ffb74d; margin: 0 0 15px;">📊 美食销量排行榜</h3>
        <div ref="barChart" style="width: 100%; height: 400px;"></div>
      </div>

      <!-- 右侧：订单状态环形图 -->
      <div class="chart-card" style="background: #222; padding: 20px; border-radius: 12px; box-shadow: 0 4px 15px rgba(0,0,0,0.5);">
        <h3 style="color: #ffb74d; margin: 0 0 15px;">🚚 订单配送状态</h3>
        <div ref="statusChart" style="width: 100%; height: 400px;"></div>
      </div>
    </div>

    <div style="margin-top: 20px; display: grid; grid-template-columns: 1fr; gap: 20px;">
      <!-- 底部：订单时间趋势 -->
      <div class="chart-card" style="background: #222; padding: 20px; border-radius: 12px; box-shadow: 0 4px 15px rgba(0,0,0,0.5);">
        <h3 style="color: #ffb74d; margin: 0 0 15px;">📈 近7日订单趋势</h3>
        <div ref="trendChart" style="width: 100%; height: 300px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as echarts from "echarts";

export default {
  name: 'OrderSalesDashboard',
  data() {
    return {
      orderData: []
    };
  },
  async mounted() {
    // 确保 ECharts 已加载
    if (typeof echarts === 'undefined') {
      console.error('ECharts 未加载，请检查 CDN 是否引入');
      return;
    }

    await this.fetchOrders();

    // 数据加载完成后初始化图表
    this.$nextTick(() => {
      this.initBarChart();
      this.initStatusChart();
      this.initTrendChart();
    });
  },
  methods: {
    async fetchOrders() {
      try {
        const response = await axios.get('http://localhost:8090/admin/getAllOrder');
        if (response.data?.data?.records) {
          this.orderData = response.data.data.records;
        } else {
          console.warn('订单数据为空或结构异常');
        }
      } catch (error) {
        console.error('获取订单数据失败:', error);
      }
    },

    // 初始化柱状图：美食销量
    initBarChart() {
      if (!this.orderData.length) return;

      const salesByFood = {};
      this.orderData.forEach(order => {
        const name = order.meishi_name || '未知美食';
        salesByFood[name] = (salesByFood[name] || 0) + 1;
      });

      const chart = echarts.init(this.$refs.barChart); // 直接使用全局 echarts

      const option = {
        color: ['#ff9800'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        xAxis: {
          type: 'category',
          data: Object.keys(salesByFood),
          axisLabel: {
            color: '#ccc',
            rotate: 20
          },
          axisLine: {
            lineStyle: { color: '#444' }
          }
        },
        yAxis: {
          type: 'value',
          name: '销量（份）',
          axisLabel: { color: '#ccc' },
          splitLine: {
            lineStyle: { color: '#333', type: 'dashed' }
          }
        },
        series: [{
          name: '销量',
          type: 'bar',
          data: Object.values(salesByFood),
          itemStyle: {
            borderRadius: [4, 4, 0, 0],
            color: '#ff9800'
          },
          emphasis: {
            itemStyle: { color: '#f57c00' }
          }
        }],
        textStyle: { color: '#ccc' }
      };

      chart.setOption(option);

      // 响应窗口缩放
      window.addEventListener('resize', () => chart.resize());
    },

    // 初始化环形图：订单状态
    initStatusChart() {
      if (!this.orderData.length) return;

      const statusCounts = { 0: 0, 1: 0, 2: 0 };
      this.orderData.forEach(order => {
        const status = order.status;
        if (status in statusCounts) {
          statusCounts[status]++;
        }
      });

      const chart = echarts.init(this.$refs.statusChart); // 直接使用 echarts

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} 单 ({d}%)'
        },
        legend: {
          bottom: '5%',
          data: ['已出库', '运输中', '已送达'],
          textStyle: { color: '#ccc' }
        },
        series: [{
          name: '配送状态',
          type: 'pie',
          radius: ['40%', '60%'],
          data: [
            { value: statusCounts[0], name: '已出库' },
            { value: statusCounts[1], name: '运输中' },
            { value: statusCounts[2], name: '已送达' }
          ],
          color: ['#4CAF50', '#FFC107', '#2196F3'],
          label: { color: '#ccc' },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }],
        textStyle: { color: '#ccc' }
      };

      chart.setOption(option);
      window.addEventListener('resize', () => chart.resize());
    },

    // 初始化趋势图：近7日订单
    initTrendChart() {
      if (!this.orderData.length) return;

      const trendData = {};
      this.orderData.forEach(order => {
        const day = new Date(order.createtime).toLocaleDateString(); // 如 "2025/4/5"
        trendData[day] = (trendData[day] || 0) + 1;
      });

      // 按日期排序（最近7天）
      const sortedEntries = Object.entries(trendData)
        .sort((a, b) => new Date(a[0]) - new Date(b[0]))
        .slice(-7); // 取最近7天

      const days = sortedEntries.map(item => item[0]);
      const counts = sortedEntries.map(item => item[1]);

      const chart = echarts.init(this.$refs.trendChart); // 直接使用 echarts

      const option = {
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: days,
          axisLabel: { color: '#ccc' },
          axisLine: { lineStyle: { color: '#444' } }
        },
        yAxis: {
          type: 'value',
          name: '订单数',
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#333' } }
        },
        series: [{
          data: counts,
          type: 'line',
          smooth: true,
          areaStyle: { color: 'rgba(255, 152, 0, 0.3)' },
          itemStyle: { color: '#ff9800' },
          lineStyle: { width: 3 }
        }],
        textStyle: { color: '#ccc' }
      };

      chart.setOption(option);
      window.addEventListener('resize', () => chart.resize());
    }
  },
  // 组件销毁时移除 resize 事件
  beforeUnmount() {
    window.removeEventListener('resize', () => {
      if (this.$refs.barChart) echarts.init(this.$refs.barChart).resize();
    });
    window.removeEventListener('resize', () => {
      if (this.$refs.statusChart) echarts.init(this.$refs.statusChart).resize();
    });
    window.removeEventListener('resize', () => {
      if (this.$refs.trendChart) echarts.init(this.$refs.trendChart).resize();
    });
  }
};
</script>

<style>
/* 滚动条美化 */
.dashboard ::-webkit-scrollbar {
  width: 6px;
}
.dashboard ::-webkit-scrollbar-track {
  background: #111;
}
.dashboard ::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 3px;
}
.dashboard ::-webkit-scrollbar-thumb:hover {
  background: #ff9800;
}
</style>
